export const FETCHED_SESSION = "FETCHED_SESSION";
export const CHANGED_SESSION = "CHANGED_SESSION";
export const STARTED_CREATE_SESSION = "STARTED_CREATE_SESSION";
export const ERRORED_CREATE_SESSION = "ERRORED_CREATE_SESSION";
